import $api from "../http";
import { AxiosResponse } from "axios";

export default class AskService {

    static getAllQA(): Promise<AxiosResponse<any>> {
        return $api.get<any>('api/q-a/')
    };

    static getAllQuestions(): Promise<AxiosResponse<any>> {
        return $api.get<any>('api/q-a/all/')
    };

    static deleteQA(id: number): Promise<AxiosResponse<any>> {
        return $api.delete<any>(`api/q-a/delete/${id}`)
    };

    static getQ(): Promise<AxiosResponse<any>> {
        return $api.get<any>('api/q-a/questions/')
    };

    static getSpecQ(): Promise<AxiosResponse<any>> {
        return $api.get<any>('api/q-a/spec_questions/')
    };

    static createQ(data: any): Promise<AxiosResponse<any>> {
        return $api.post<any>('api/q-a/questions/', data)
    };

    // static updateQA(id: number, data: any): Promise<AxiosResponse<any>> {
    //     return $api.patch<any>(`api/q-a/update/${id}`, data)
    // };

    // static getA(params: any): Promise<AxiosResponse<any>> {
    //     return $api.get<any>(`api/q-a/answers/`, {params})
    // };

    static createA(data: any): Promise<AxiosResponse<any>> {
        return $api.post<any>('api/q-a/answers/', data)
    };

    static createC(data: any): Promise<AxiosResponse<any>> {
        return $api.post<any>('api/q-a/comments/', data)
    };

};